/**
 * DevExtreme (esm/__internal/scheduler/view_model/filtering/utils/shift_intervals.js)
 * Version: 25.1.6
 * Build date: Mon Oct 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 * Read about DevExtreme licensing here: https://js.devexpress.com/Licensing/
 */
import { dateUtilsTs } from "../../../../core/utils/date";
export const shiftIntervals = (intervals, viewOffset) => intervals.map(interval => ({
  min: dateUtilsTs.addOffsets(interval.min, [viewOffset]),
  max: dateUtilsTs.addOffsets(interval.max, [viewOffset])
}));